(function () {

  // Auto-detect all variant option values for this product from the page
  function getProductVariants() {
    const values = new Set();

    // From radio buttons
    document.querySelectorAll('input[type="radio"].product-form__input, variant-radios input[type="radio"], fieldset input[type="radio"]')
      .forEach(function (input) {
        if (input.value) values.add(input.value.trim());
      });

    // From select dropdowns
    document.querySelectorAll('variant-selects select, select.product-form__input')
      .forEach(function (select) {
        Array.from(select.options).forEach(function (opt) {
          if (opt.value) values.add(opt.value.trim());
        });
      });

    return values;
  }

  function filterGallery(selectedVariant) {
    const variant = selectedVariant.trim();
    const VARIANTS = getProductVariants();

    // If we couldn't detect any variants, do nothing
    if (VARIANTS.size === 0) return;

    // --- Filter main slides ---
    document.querySelectorAll('li.product__media-item').forEach(function (slide) {
      const img = slide.querySelector('img');
      if (!img) return;
      const alt = (img.getAttribute('alt') || '').trim();
      if (VARIANTS.has(alt)) {
        slide.style.display = alt === variant ? '' : 'none';
      } else {
        slide.style.display = ''; // untagged images always visible
      }
    });

    // --- Filter thumbnails ---
    document.querySelectorAll('li.thumbnail-list__item').forEach(function (thumb) {
      const img = thumb.querySelector('img');
      if (!img) return;
      const alt = (img.getAttribute('alt') || '').trim();
      if (VARIANTS.has(alt)) {
        thumb.style.display = alt === variant ? '' : 'none';
      } else {
        thumb.style.display = '';
      }
    });

    // --- Scroll to first visible slide ---
    setTimeout(function () {
      const firstVisible = document.querySelector(
        'li.product__media-item:not([style*="none"])'
      );
      if (firstVisible) {
        firstVisible.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      }
    }, 50);
  }

  function getSelectedVariant() {
    // Radio buttons
    const checkedRadio = document.querySelector(
      'variant-radios input[type="radio"]:checked, fieldset input[type="radio"]:checked'
    );
    if (checkedRadio) return checkedRadio.value;

    // Select dropdown
    const select = document.querySelector(
      'variant-selects select, select.product-form__input'
    );
    if (select) return select.options[select.selectedIndex]?.value || '';

    return '';
  }

  function init() {
    // Filter on page load
    const initial = getSelectedVariant();
    if (initial) filterGallery(initial);

    // Filter on variant change
    document.addEventListener('change', function (e) {
      const isVariantInput = e.target.closest(
        'variant-selects, variant-radios, fieldset, form[action*="/cart/add"]'
      );
      if (!isVariantInput) return;

      let value = '';
      if (e.target.type === 'radio') {
        value = e.target.value;
      } else if (e.target.tagName === 'SELECT') {
        value = e.target.options[e.target.selectedIndex]?.value || '';
      }

      if (value) filterGallery(value);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();